var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelAudioFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#6384EB",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.133 8.687c.654-.13.951-.197.951.496v6.314c0 .692-.297.625-.951.496L8.52 13.916H7.332c-.33 0-.596-.28-.596-.63v-1.892c0-.348.26-.63.596-.63H8.52Zm3.892.295a.493.493 0 0 1 .684-.05 4.44 4.44 0 0 1 1.612 3.407 4.44 4.44 0 0 1-1.612 3.41.49.49 0 0 1-.684-.052.464.464 0 0 1 .053-.667 3.5 3.5 0 0 0 1.273-2.69 3.5 3.5 0 0 0-1.274-2.69.465.465 0 0 1-.052-.668m-1.579 1.546a.493.493 0 0 1 .677-.109 2.35 2.35 0 0 1 1.017 1.92c0 .759-.38 1.477-1.017 1.921a.5.5 0 0 1-.282.088c-.15 0-.3-.068-.395-.197a.464.464 0 0 1 .112-.66c.384-.267.613-.698.613-1.152a1.41 1.41 0 0 0-.613-1.15.465.465 0 0 1-.112-.66"
}))));
export default SvgGemChannelAudioFilled;